import { createTheme } from '@mui/material/styles';
import { components } from './components';
import { lightPalette, radius } from './palette';
import { typography } from './typography';

export const theme = createTheme({
  palette: lightPalette,
  shape: { borderRadius: radius.control },
  spacing: 8,
  typography,
  components,
});

export { elevation } from './palette';
